import { render, staticRenderFns } from "./SelectTariff.vue?vue&type=template&id=6cea336f"
import script from "./SelectTariff.vue?vue&type=script&lang=js"
export * from "./SelectTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports